import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      position="bottom-left"
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#0081EB] group-[.toaster]:text-white group-[.toaster]:border-[#0081EB] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-white/80",
          actionButton:
            "group-[.toast]:!bg-transparent group-[.toast]:!text-white group-[.toast]:underline group-[.toast]:hover:!bg-white/10",
          cancelButton:
            "group-[.toast]:!bg-transparent group-[.toast]:!text-white group-[.toast]:!border group-[.toast]:!border-white group-[.toast]:hover:!bg-white/10 group-[.toast]:!ml-2"
        }
      }}
      {...props}
    />
  );
};

export { Toaster };
